export default __webpack_public_path__ + "static/media/contacto-menu.864f7eff.svg";